document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="cp-custom-card-trigger-"]').forEach((trigger) => {
      const blockId = trigger.id.replace('cp-custom-card-trigger-', '');
      const overlay = document.getElementById(`cp-custom-popup-overlay-${blockId}`);
      const closeButton = document.getElementById(`cp-custom-close-popup-${blockId}`);
      const iframe = overlay.querySelector('iframe'); // Find the iframe inside the popup
      let player = null;

      if (iframe) {
        player = new Vimeo.Player(iframe); // Initialize Vimeo player

         // Ensure iframe has a descriptive title
        if (!iframe.title) {
            iframe.title = 'Vimeo player';
        }
      }

      if (trigger && overlay && closeButton) {
        trigger.addEventListener('click', () => {
          overlay.style.display = 'block';
          overlay.style.opacity = '1';
          if (player) {
            player.play(); // Auto-play video when popup opens
          }
        });

        closeButton.addEventListener('click', () => {
          overlay.style.display = 'none';
          overlay.style.opacity = '0';
          if (player) {
            player.pause(); // Pause video when popup closes
          }
        });

        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) {
            overlay.style.opacity = '0';
            overlay.style.display = 'none';
            if (player) {
              player.pause(); // Pause video when clicking outside
            }
          }
        });
      }
    });
  });